import classNames from "classnames";
import Svg13 from "@assets/icons/svg13.svg?react";

const VALUE_TEXT_CLASS = "font-400 text-16";
const MOON_LABEL_CLASS = "font-weight-300 text-12 color-[var(--app-text-14)] text-ellipsis-2";

export const useCptUtil_02 = ({ getCls02, forecast1day, current, $t }: any) => {
  const getCpt02 = () => {
    // 工具方法：判断是否白天
    const isDayTime = current?.IsDayTime * 1 === 1;

    // 工具方法：获取日月进度数据
    const sunMoonKey = isDayTime ? "Sun" : "Moon";
    const sunMoonRate = forecast1day?.[sunMoonKey]?.rate;

    const renderProgressIcon = () => (isDayTime ? <SvgIcon name="svg12" size={20} /> : <Svg13 />);

    const renderMoonNextDaySuffix = () =>
      forecast1day?.Moon?.NextDay > 0 ? "+" + forecast1day.Moon.NextDay : "";

    return (
      <>
        {/* 日出日落 */}
        <div className="w-full flex justify-between items-center gap-x-16">
          <div className="flex flex-col items-stretch gap-y-2">
            <span className={classNames(getCls02())}>{$t("title12")}</span>
            <span className={VALUE_TEXT_CLASS}>{forecast1day?.["Sun"]?.Rise}</span>
          </div>
          <div className={classNames(["flex flex-col gap-y-2 items-end"])}>
            <span className={classNames(getCls02())}>{$t("title13")}</span>
            <span className={VALUE_TEXT_CLASS}>{forecast1day?.["Sun"]?.Set}</span>
          </div>
        </div>

        {/* 日月进度条 */}
        <div className="flex items-center gap-x-4 w-full">
          <div className="h-8 bg-[var(--app-bg-16)] rounded-15" style={{ width: `${sunMoonRate}%` }}></div>
          <div className="icon">{renderProgressIcon()}</div>
          <div className="h-8 bg-[var(--app-bg-17)] rounded-15" style={{ width: `${100 - sunMoonRate}%` }}></div>
        </div>

        {/* 月升月落 */}
        <div className="w-full flex justify-between items-center gap-x-16">
          <div className="flex flex-col items-stretch gap-y-2">
            <span className={MOON_LABEL_CLASS}>{$t("title14")}</span>
            <span className={VALUE_TEXT_CLASS}>{forecast1day?.["Moon"]?.Rise}</span>
          </div>
          <div className=" flex flex-col items-end gap-y-2">
            <span className={MOON_LABEL_CLASS}>{$t("title15")}</span>
            <span className="flex gap-x-4 items-baseline">
              <span className={VALUE_TEXT_CLASS}>{forecast1day?.["Moon"]?.Set}</span>
              <span className="text-10 ">{renderMoonNextDaySuffix()}</span>
            </span>
          </div>
        </div>
      </>
    );
  };

  return { getCpt02 };
};
